import {
  Component,
  AfterViewInit,
  EventEmitter,
  Output,
  OnInit,
  ViewChild,

} from '@angular/core';
import { NgbDropdown, NgbDropdownModule, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
declare var $: any;
import { AuthService } from '../../services/auth/auth.service';
import { CommonModule, NgIf } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ToastService } from 'src/app/toast/toast.service';
import { ConfigService } from 'src/app/services/auth/config.service';
@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [NgbDropdownModule, RouterModule,CommonModule,NgIf],
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements AfterViewInit,OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();
  @ViewChild('notifDropdown') notifDropdown!: NgbDropdown;
  notificationCount = 3;
  public showSearch = false;
  userrolename: string = '';
userName='';
visibleNotifications: any[] = [];
  showAll = false;
  showNotifications = false;
  errorMessage: string='';
  notifications:any[]=[];
  notificationsList: any;
  imageurl: any =null; // Default image URL
  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private toastService:ToastService,
    private notificationService:NotificationService,
    private _Cf1: ConfigService,

  ) {}
  isAuthenticated: Boolean = false;
  roleId:any;
  token:any;
  ngOnInit(): void {
  // this.checkAndLogoutIfExpired();
  
       this.authService.currentUserSubject.subscribe((r)=>{
        this.isAuthenticated = r
      });
      this.userName=this.authService?.currentUserValue?.firstName+' '+ (this.authService?.currentUserValue?.lastName ? this.authService?.currentUserValue?.lastName :'');
      this.userrolename=this.authService?.currentUserValue?.roleName;
      if(this.authService?.currentUserValue?.imageurl){
        this.imageurl =this._Cf1.getprofileUrl()+this.authService?.currentUserValue?.imageurl;
      }

      //this.visibleNotifications = this.notifications.slice(0, 3);
      this.roleId = this.authService.currentUserValue?.roleId;
      if(this.roleId){
        this.getNotifications(1, this.roleId);
      }
      this.token = localStorage.getItem('authToken');

  }

  // This is for Notifications
  // notifications: Object[] = [
  //   {
  //     btn: 'btn-danger',
  //     icon: 'ti-link',
  //     title: 'Luanch Admin',
  //     subject: 'Just see the my new admin!',
  //     time: '9:30 AM',
  //   },
  //   {
  //     btn: 'btn-success',
  //     icon: 'ti-calendar',
  //     title: 'Event today',
  //     subject: 'Just a reminder that you have event',
  //     time: '9:10 AM',
  //   },
  //   {
  //     btn: 'btn-info',
  //     icon: 'ti-settings',
  //     title: 'Settings',
  //     subject: 'You can customize this template as you want',
  //     time: '9:08 AM',
  //   },
  //   {
  //     btn: 'btn-warning',
  //     icon: 'ti-user',
  //     title: 'Pavan kumar',
  //     subject: 'Just see the my admin!',
  //     time: '9:00 AM',
  //   },
  // ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/user1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM',
    },
    {
      useravatar: 'assets/images/users/user2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM',
    },
    {
      useravatar: 'assets/images/users/user2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM',
    },
    {
      useravatar: 'assets/images/users/user4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM',
    },
  ];

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: 'us',
    },
    {
      language: 'Español',
      code: 'es',
      icon: 'es',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: 'fr',
    },
    {
      language: 'German',
      code: 'de',
      icon: 'de',
    },
  ];

  ngAfterViewInit() {}
  logOut()
  {
    this.authService.logout();
  }
  checkAndLogoutIfExpired(): void {
    if (this.authService.isTokenExpired(this.token)) {
       this.authService.logout();
        this.isAuthenticated = false;
    }
  }
  toggleNotificationDropdown(event: MouseEvent) {
    this.showAll = false;
    
    // No dropdown toggle logic needed with ngbDropdown
    if (!this.showAll) {
      this.visibleNotifications = this.notifications.slice(0, 3);
    }
    // if(this.notifications.length==0){
    //   this.getNotifications(1, this.authService.currentUserValue.roleId);
    // }
  }
  modalRef: NgbModalRef | any;
  viewMore(content:any){
      this.notifications=[];
      this.modalRef = this.modalService.open(content,{size:'lg'});
    
  }
  // viewMore(event: MouseEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.showAll = true;
  //   this.visibleNotifications = this.notificationsList;
  //   setTimeout(() => this.notifDropdown.open(), 0);
  // }
  getNotifications(flag:number, RoleId:number){
    this.notificationService.getNotifications(flag, RoleId).subscribe(
      (response) => {
        if (response.status === 200) {
          this.notifications = response.data;
          this.notificationsList = response.data;
          this.visibleNotifications = this.notifications.slice(0, 3);
          this.notificationCount = this.notifications.length;
          
        } else {
        }
      },
      (error) => {
        
        this.toastService.showError(error);
        this.errorMessage = 'Error fetching raised master details: ' + error.message;
        console.error('Error fetching society details:', error);
      
      });
  }
  readNotification(event: MouseEvent, id: any) {
    event.preventDefault();
    event.stopPropagation();
    this.notificationService.updateNotification(id, this.roleId).subscribe(
      (response) => {
        if (response.status === 200) {
          
          // Remove the clicked notification from the main list
    this.notifications = this.notifications.filter((x: { Id: any }) => x.Id !== id);
  
    // Update the visible notifications
    this.visibleNotifications = this.showAll
      ? this.notifications
      : this.notifications.slice(0, 3);
        } else {
        }
      },
      (error) => {
        
        this.toastService.showError(error);
        this.errorMessage = 'Error fetching raised master details: ' + error.message;
        console.error('Error fetching society details:', error);
      
      });
    
  
    // Reopen the dropdown (in case it got closed)
    setTimeout(() => {
      if (!this.notifDropdown.isOpen()) {
        this.notifDropdown.open();
      }
    }, 0);
  }
  
}
